<template>
  <div class="app">
    <!-- 头部导航 -->
    <header class="header">
      <div class="container">
        <h1 class="title">株洲市芦淞区中医骨伤专科医院</h1>
        <p class="subtitle">传承中医精髓 · 新建民生工程</p>
      </div>
    </header>

    <!-- 主体内容 -->
    <main class="main container">
      <!-- 医院简介 -->
      <section class="section about">
        <h2 class="section-title">医院简介</h2>
        <div class="about-content">
          <div class="about-info">
            <p>株洲市芦淞区中医骨伤专科医院坐落于株洲市芦淞区姚家坝地区，是一所集医疗、康复、预防保健于一体的中医医院。</p>
            <p>当前医院建筑面积4800多平方米，开放床位120张，临床科室有正骨科、创伤科、筋伤科、综合内科、治未病科、门急诊6个临床科室。</p>
            <p>医技科室设有药剂科、检验科、手术室、放射科、超声科、心电图室等6个科室。</p>
            <h3>先进设备</h3>
            <p>拥有西门子32排螺旋式CT、全数字化DRX光机、1.0千伏C型臂、全身麻醉机、多功能三维电脑微控牵引床、彩超、全自动生化仪等大中型设备。</p>
            <h3>办院宗旨与理念</h3>
            <p><strong>办院宗旨：</strong>"中医为本、病人为先、弘扬特色、追求卓越"</p>
            <p><strong>办院理念：</strong>"传承中医精髓，弘扬正骨技艺"</p>
          </div>
          <!-- <div class="about-image">
            <img src="https://picsum.photos/600/400?random=hospital" alt="医院外观" class="rounded">
          </div> -->
        </div>
      </section>

      <!-- 医院特色 -->
      <section class="section features">
        <h2 class="section-title">医院特色</h2>
        <div class="features-grid">
          <div v-for="(feature, index) in features" :key="index" class="feature-card">
            <div class="feature-icon">
              <i :class="feature.icon"></i>
            </div>
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
          </div>
        </div>
      </section>

      <!-- 新建项目概况 -->
      <section class="section project">
        <h2 class="section-title">择址新建项目概况</h2>
        <div class="project-card">
          <h3 class="project-subtitle">项目基本信息</h3>
          <div class="project-info">
            <div class="info-item">
              <span class="info-label">项目名称</span>
              <span>芦淞区白关镇中心卫生院暨株洲市芦淞区中医骨伤专科医院择址新建项目</span>
            </div>
            <div class="info-item">
              <span class="info-label">项目定位</span>
              <span>市区重点民生项目，湖南省地方政府专项债券项目</span>
            </div>
            <div class="info-item">
              <span class="info-label">建设地址</span>
              <span>株洲市芦淞区白关镇白关社区</span>
            </div>
            <div class="info-item">
              <span class="info-label">建设规模</span>
              <span>总用地面积约17652㎡（26.48亩），总建筑面积约25057㎡</span>
            </div>
            <div class="info-item">
              <span class="info-label">总投资</span>
              <span>2.3亿元</span>
            </div>
          </div>
        </div>

        <!-- <div class="project-card">
          <h3 class="project-subtitle">项目名称说明</h3>
          <div class="project-text">
            <p>2022年申报时因原姚家坝卫生院行政许可手续未完成，且计划与白关卫生院合并，故采用联合命名。目前已完成两院合并，设立<strong>芦淞区中医骨伤专科医院</strong>，并通过二级专科医院验收，成为芦淞区政府唯一公立二级专科区级医院。项目名称沿用原申报名，实际建设主体为中医骨伤专科医院。</p>
          </div>
        </div> -->

        <div class="project-card">
          <h3 class="project-subtitle">项目发展前景</h3>
          <div class="project-text">
            <p><strong>特色定位：</strong>以"北张正骨术"为核心，筹建"大专科、小综合"型医院。</p>
            <p><strong>品牌优势：</strong>"北张正骨术"为湖南省非遗项目（正在申报国家非遗），院长张进工作室为"全国基层名老中医药专家传承工作室"，中医骨伤科为省级重点专科。</p>
            <p><strong>医疗能力：</strong>采用"北张正骨手法复位+中医康复治疗"模式，配置先进设备，开放床位240张，具备区域辐射能力。</p>
          </div>
        </div>

        <div class="project-card">
          <h3 class="project-subtitle">项目进度与计划</h3>
          <div class="progress-timeline">
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-date">2022年6月</div>
                <div class="timeline-text">项目列入湖南省专项债券项目，计划建设周期2022.6-2024.5</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-date">2022年底</div>
                <div class="timeline-text">受疫情影响项目启动受阻</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-date">2023年起</div>
                <div class="timeline-text">完成"一件三证"（用地许可、工程规划许可、施工许可）、招投标、开工仪式及桩基工程</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-date">2025年底</div>
                <div class="timeline-text">主体工程完工</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-date">2026年3月</div>
                <div class="timeline-text">竣工验收</div>
              </div>
            </div>
          </div>
        </div>

        <div class="project-card">
          <h3 class="project-subtitle">附件材料</h3>
          <div class="attachments">
            <div class="attachment-item">
              <div class="attachment-icon">
                <i class="fas fa-file-medical"></i>
              </div>
              <div class="attachment-info">
                <h4>《医疗机构执业许可证》</h4>
                <p>登记为二级骨科医院，非营利性政府办机构，床位100张，诊疗科目涵盖骨伤科、康复科等。</p>
                    
                <img  width="500" src="../../assets/yyimages/医疗机构执业许可证1.png">
              </div>
            </div>
            <div class="attachment-item">
              <div class="attachment-icon">
                <i class="fas fa-building"></i>
              </div>
              <div class="attachment-info">
                <h4>《事业单位法人证书》</h4>
                <p>宗旨为"发挥中医优势提供医疗与护理保健服务"，有效期至2029年11月。</p>
                <img width="500" src="../../assets/yyimages/法人证书1.png">
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>株洲市芦淞区中医骨伤专科医院 &copy; {{ currentYear }} 版权所有</p>
        <p>地址：株洲市芦淞区白关镇姚家坝地区</p>
      </div>
    </footer>
  </div>
</template>



<script>
export default {
  name: "HospitalProjectIntroduction",
  data() {
    return {
      
      features: [
        {
          title: "中医正骨传承",
          description: "以传统手法复位、小夹板固定、中药内服外敷等疗法为主，治疗骨折、脱臼等骨伤疾病，创伤小、恢复快。",
          icon: "fas fa-bone"
        },
        {
          title: "专科优势",
          description: "专注骨伤科、疼痛科、康复科，对腰椎间盘突出、颈椎病等慢性骨病提供中西医结合治疗方案。",
          icon: "fas fa-hospital"
        },
        {
          title: "个性化康复",
          description: "配备现代化康复设备，结合针灸、推拿、理疗等手段，加速患者功能恢复。",
          icon: "fas fa-rehabilitation"
        },
        {
          title: "微创骨科技术",
          description: "传承中医正骨手法，引进经皮椎体成形术、关节镜手术等微创技术，适合老年骨病患者。",
          icon: "fas fa-tools"
        }
      ]
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>



/* 响应式调整 */
@media (max-width: 768px) {
  .pdf-frame {
    height: 400px;
  }
}
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.6;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 头部样式 */
.header {
  background: linear-gradient(135deg, #4CAF50, #388E3C);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.header::after {
  content: "";
  position: absolute;
  bottom: -50px;
  left: 0;
  width: 100%;
  height: 100px;
  background: white;
  border-radius: 50% 50% 0 0;
}

.title {
  font-size: 2.8rem;
  margin-bottom: 15px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto;
}

/* 主体内容样式 */
.main {
  padding: 60px 0;
}

.section {
  margin-bottom: 80px;
  position: relative;
}

.section-title {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 40px;
  color: #333;
  position: relative;
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #4CAF50;
  border-radius: 3px;
}

/* 医院概况样式 */
.about-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  overflow: hidden;
}

.about-info {
  flex: 1;
  padding: 40px;
}

.about-image {
  flex: 1;
  min-width: 300px;
  height: 300px;
  overflow: hidden;
}

.about-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.about-image img:hover {
  transform: scale(1.03);
}

/* 特色卡片样式 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 20px;
}

.feature-card {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.feature-icon {
  font-size: 3rem;
  color: #4CAF50;
  margin-bottom: 20px;
}

/* 项目卡片样式 */
.project-card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  padding: 30px;
  margin-bottom: 30px;
  transition: transform 0.3s ease;
}

.project-card:hover {
  transform: translateY(-5px);
}

.project-subtitle {
  font-size: 1.5rem;
  color: #4CAF50;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.project-info {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.info-item {
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.info-label {
  font-weight: bold;
  color: #4CAF50;
  margin-bottom: 5px;
  display: block;
}

.project-text {
  line-height: 1.8;
  color: #555;
}

/* 时间线样式 */
.progress-timeline {
  position: relative;
  margin-left: 30px;
  padding-left: 20px;
  border-left: 2px solid #4CAF50;
}

.timeline-item {
  position: relative;
  margin-bottom: 30px;
  padding-left: 20px;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: -31px;
  top: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #4CAF50;
  border: 3px solid white;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

.timeline-date {
  font-weight: bold;
  color: #4CAF50;
  margin-bottom: 5px;
}

/* 附件样式 */
.attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.attachment-item {
  flex: 1;
  min-width: 280px;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
}

.attachment-icon {
  font-size: 2rem;
  color: #4CAF50;
  margin-right: 15px;
}

.attachment-info h4 {
  margin-bottom: 5px;
  color: #333;
}

/* 页脚样式 */
.footer {
  background-color: #333;
  color: white;
  padding: 40px 0;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .title {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .about-info, .about-image {
    flex: 100%;
    min-width: 100%;
  }
  
  .about-info {
    padding: 20px;
  }
  
  .about-image {
    height: 250px;
  }
  
  .section-title {
    font-size: 1.6rem;
  }
  
  .features-grid, .project-info, .attachments {
    grid-template-columns: 1fr;
  }
  
  .progress-timeline {
    margin-left: 20px;
  }
}

/* 图标样式 (需配合Font Awesome) */
.fas {
  transition: transform 0.3s ease;
}

.feature-card:hover .fas, .attachment-item:hover .fas {
  transform: rotate(10deg) scale(1.1);
}
</style>